import React from 'react';
import { Handle, Position } from '@xyflow/react';

const POS = { left: Position.Left, top: Position.Top, bottom: Position.Bottom, right: Position.Right };

// A short "cable end" for connections whose counterpart device is NOT on the
// detail page. Shows the counterpart device + port as a label. handlePos picks
// the side the cable attaches (left for list view, top/bottom for panel view).
// In panel view (data.vertical) the label is rotated 90° so it stays within the
// port column (one label per port, side by side) instead of overlapping.
export const DetailStubNode = ({ data }) => {
  const pos = POS[data.handlePos] || Position.Left;
  const text = data.otherPort ? `${data.otherName} \u00b7 ${data.otherPort}` : data.otherName;

  if (data.vertical) {
    // handlePos 'bottom' => label sits ABOVE the device (read upward);
    // handlePos 'top' => label sits BELOW the device (read downward).
    const readUp = data.handlePos === 'bottom';
    return (
      <div data-testid="detail-stub-node" className="relative" style={{ width: 18, height: 120 }}>
        <Handle
          type="target"
          position={pos}
          id="in"
          style={{ width: 7, height: 7, background: '#fff', border: '1.5px solid #5B6672' }}
        />
        <div className="absolute inset-0 flex items-center justify-center overflow-hidden rounded-md border border-dashed border-[#5B6672]/70 bg-white/95 shadow-sm">
          <span
            className="whitespace-nowrap text-[10px] font-semibold text-[#2A3138]"
            style={{ writingMode: 'vertical-rl', transform: readUp ? 'rotate(180deg)' : 'none' }}
            title={text}
          >
            {text}
          </span>
        </div>
      </div>
    );
  }

  return (
    <div data-testid="detail-stub-node" className="relative flex items-center" style={{ width: 134 }}>
      <Handle
        type="target"
        position={pos}
        id="in"
        style={{ width: 7, height: 7, background: '#fff', border: '1.5px solid #5B6672' }}
      />
      <div className="w-full rounded-md border border-dashed border-[#5B6672]/70 bg-white/95 px-2 py-1 text-[10px] leading-tight text-[#2A3138] shadow-sm">
        <div className="truncate font-semibold">{data.otherName}</div>
        {data.otherPort ? <div className="truncate font-mono text-[#5B6672]">{data.otherPort}</div> : null}
      </div>
    </div>
  );
};
